<div class="banners" #banners>
    @if (Settings.isTest()) {
        <div class="test">
            {{ version.environment }} - {{ version.datetime | date: 'EEE dd MMM yyyy HH:mm:ss' }} -
            {{ version.buildId }}
        </div>
    }

    @if (parentUser) {
        <div class="parent-user" (click)="backToParentUser()">
            Je hebt als {{ parentUser?.name }} het account van {{ user?.name }} overgenomen. Klik hier om terug te gaan
            naar je eigen account.
        </div>
    }
</div>

@if (!hideHeader) {
    <div class="mainheader user-select-none">
        <div class="container">
            <div class="row flex-nowrap">
                <div class="col align-items-center d-flex">
                    <a
                        (click)="showBackButton && navigateBack()"
                        (keydown.enter)="showBackButton && navigateBack()"
                        (keydown.space)="showBackButton && navigateBack(); showBackButton && $event.preventDefault()"
                        [attr.role]="showBackButton ? 'button' : null"
                        [attr.tabindex]="showBackButton ? 0 : null"
                        class="back-action">
                        @if (showBackButton) {
                            <div class="icon"></div>
                        }
                        <div class="text" [class.mobile-search]="showSearchMobile && !hideSearch">
                            @if (routeTitle) {
                                <div [innerHTML]="routeTitle | safeHtml"></div>
                            }
                            <div class="customer-and-project">
                                {{ customerMap.get(+routeParams.params[RouteParamnames.customerId]) }}
                                @if (projectMap.get(+routeParams.params[RouteParamnames.projectId])) {
                                    -
                                }
                                {{ projectMap.get(+routeParams.params[RouteParamnames.projectId]) }}
                            </div>
                        </div>
                    </a>
                    @if (!hideSearch) {
                        <div class="flex-fill d-flex d-md-none justify-content-end">
                            <div class="search-button" (click)="showSearchMobile = !showSearchMobile">
                                <div class="search-icon"></div>
                            </div>
                        </div>
                    }
                </div>

                @if (searchService.searchTemplate) {
                    <div class="col col-sm-auto d-flex align-items-center justify-content-start text-end">
                        <ng-container [ngTemplateOutlet]="searchService.searchTemplate"></ng-container>
                    </div>
                }

                @if (!hideSearch) {
                    <div
                        [class.d-none]="!showSearchMobile"
                        class="d-md-flex col col-sm-auto align-items-center justify-content-start text-end search-input">
                        <mat-form-field class="w-100">
                            <input
                                #searchInput
                                [formControl]="fcSearch"
                                autocomplete="off"
                                matInput
                                placeholder="Zoeken... (Ctrl + F)"
                                type="text" />
                        </mat-form-field>
                    </div>
                }

                <div
                    class="col col-auto d-none d-md-flex align-items-center"
                    [class.d-flex]="hideSearch && !searchService.searchTemplate">
                    <div class="logo-small" routerLink="/"></div>
                </div>
            </div>
        </div>
    </div>
}
@if (!hideHeader) {
    <div class="mainbalk">
        <div class="container">
            <div class="row">
                <div class="spacer"></div>
            </div>
        </div>
    </div>
}

<div class="router-outlet">
    <router-outlet></router-outlet>
</div>
@if (!hideHeader) {
    <nav class="nav">
        <div class="container px-1">
            <ul class="list">
                @if (!hideMenuContent) {
                    @for (bm of bottomMenu; track bm) {
                        @if (bm.visible()) {
                            <li [class.active]="bm.active" [routerLink]="bm.routerLink" class="item">
                                <div class="link">
                                    <svg-icon src="assets/svg/{{ bm.icon }}.svg"></svg-icon>
                                    @if (bm.badge) {
                                        <span class="badge">{{ bm.badge }}</span>
                                    }
                                    <span class="text">{{ bm.name }}</span>
                                </div>
                            </li>
                        }
                    }
                }
            </ul>
        </div>
    </nav>
}
